/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M19.8058.0102A4.5635 4.5635 0 0 0 19.5 0h-15C3.3312 0 2.2665.4456 1.4665 1.1762.6369 1.9337.0919 2.9975.0105 4.1889A4.564 4.564 0 0 0 0 4.5v15.0001c.0001 1.1688.4457 2.2335 1.1763 3.0335.7575.8296 1.8214 1.3745 3.0126 1.4559l.0054.0004A4.5673 4.5673 0 0 0 4.5 24h15c.1483 0 .2949-.0072.4396-.0212.9953-.0964 1.8955-.517 2.5939-1.155.8296-.7575 1.3745-1.8214 1.4559-3.0126l.0004-.0054a4.5707 4.5707 0 0 0 .0101-.2755L24 19.5v-15c0-.1483-.0072-.295-.0212-.4396-.0964-.9953-.517-1.8955-1.155-2.594C22.0663.637 21.0024.092 19.8111.0107l-.0053-.0004ZM19.5 1.5l.2239.0082C21.2762 1.6227 22.5 2.9185 22.5 4.5v15l-.0082.2239C22.3772 21.2762 21.0815 22.5 19.5 22.5h-15l-.2239-.0082C2.7238 22.3772 1.5 21.0815 1.5 19.5v-15l.0082-.2239C1.6227 2.7238 2.9185 1.5 4.5 1.5h15ZM15 12.7466l4.562.0053L12 3.2994 4.4395 12.75H9v7.5h6v-7.5034ZM10.5 11.25v7.5h3v-7.5054l2.937.0039-4.4368-5.5482L7.56 11.25h2.94Z"
    clipRule="evenodd"
  />,
  'Shift'
);
